import {
    GET_AEM_CONTENT,
    GET_AEM_CONTENT_SUCCESS,
    GET_AEM_CONTENT_FAILURE,
} from '../../constants';
import { getAEMContent as getAEMContentService } from '../../services';

export const getAEMContentSuccess = (AEMContent) => ({
    type: GET_AEM_CONTENT_SUCCESS,
    AEMContent,
    error: null,
    isLoading: false,
});

export const getAEMContentFailure = (error) => ({
    type: GET_AEM_CONTENT_FAILURE,
    error,
    isLoading: false,
});

export const getAEMContent = (productID) => async (dispatch) => {
    try {
        dispatch({ type: GET_AEM_CONTENT, isLoading: true });
        const AEMContent = await getAEMContentService(productID);
        dispatch(getAEMContentSuccess(AEMContent.productRecommender));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        dispatch(getAEMContentFailure(err));
    }
};
